import { contains, exists, ofArray } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { equals, stringHash } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import { Union, Record } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { tuple_type, lambda_type, unit_type, array_type, decimal_type, union_type, list_type, option_type, enum_type, int32_type, record_type, bool_type, string_type, class_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { create } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Date.js";
import { FSharpResult$2 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Result.js";

export const Roles_adminRoles = ofArray(["Admin", "AdminFaq", "AdminFiles", "AdminNews"]);

export const Roles_kundeRoles = ofArray(["Kunde", "KundeAdministrator", "KundeDtaVerfahren", "KundeKostenpflichtigBuchen", "KundeMitApiToken", "KundeMitSendungenAnzeigen", "KundeMitPwa", "KundeNeukunde"]);

export function Roles_IsSomeAdmin(roles) {
    return exists((r) => contains(r, Roles_adminRoles, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), roles);
}

export function Roles_IsSomeKunde(roles) {
    return exists((r) => contains(r, Roles_kundeRoles, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), roles);
}

export function Roles_shouldBeInKundeMitApiTokenRole(kundenTypId) {
    return equals(kundenTypId, 5);
}

export class News_NewsListItem extends Record {
    constructor(Id, Datum, Titel, Textanfang, HasImage, IsNew) {
        super();
        this.Id = Id;
        this.Datum = Datum;
        this.Titel = Titel;
        this.Textanfang = Textanfang;
        this.HasImage = HasImage;
        this.IsNew = IsNew;
    }
}

export function News_NewsListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.NewsListItem", [], News_NewsListItem, () => [["Id", class_type("System.Guid")], ["Datum", class_type("System.DateTime")], ["Titel", string_type], ["Textanfang", string_type], ["HasImage", bool_type], ["IsNew", bool_type]]);
}

export class News_News extends Record {
    constructor(Titel, Html, Datum, HasImage, IsNew) {
        super();
        this.Titel = Titel;
        this.Html = Html;
        this.Datum = Datum;
        this.HasImage = HasImage;
        this.IsNew = IsNew;
    }
}

export function News_News_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.News", [], News_News, () => [["Titel", string_type], ["Html", string_type], ["Datum", class_type("System.DateTime")], ["HasImage", bool_type], ["IsNew", bool_type]]);
}

export class News_LatestNewsListItem extends Record {
    constructor(Id, Titel, Textanfang) {
        super();
        this.Id = Id;
        this.Titel = Titel;
        this.Textanfang = Textanfang;
    }
}

export function News_LatestNewsListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.LatestNewsListItem", [], News_LatestNewsListItem, () => [["Id", class_type("System.Guid")], ["Titel", string_type], ["Textanfang", string_type]]);
}

export class News_AdminNews extends Record {
    constructor(Titel, Text$, GueltigAb, Aktiv, KundenTyp, Kundennummern, Bundeslaender) {
        super();
        this.Titel = Titel;
        this.Text = Text$;
        this.GueltigAb = GueltigAb;
        this.Aktiv = Aktiv;
        this.KundenTyp = KundenTyp;
        this.Kundennummern = Kundennummern;
        this.Bundeslaender = Bundeslaender;
    }
}

export function News_AdminNews_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.AdminNews", [], News_AdminNews, () => [["Titel", string_type], ["Text", string_type], ["GueltigAb", class_type("System.DateTime")], ["Aktiv", bool_type], ["KundenTyp", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))], ["Kundennummern", list_type(int32_type)], ["Bundeslaender", list_type(class_type("System.Guid"))]]);
}

export class News_BundeslandInfo extends Record {
    constructor(Id, Abkuerzung, Bezeichnung) {
        super();
        this.Id = Id;
        this.Abkuerzung = Abkuerzung;
        this.Bezeichnung = Bezeichnung;
    }
}

export function News_BundeslandInfo_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.BundeslandInfo", [], News_BundeslandInfo, () => [["Id", class_type("System.Guid")], ["Abkuerzung", string_type], ["Bezeichnung", string_type]]);
}

export class News_AdminNewsListItem extends Record {
    constructor(Id, Titel, Datum, Aktiv, AnzeigeConstraint, Bundeslaender) {
        super();
        this.Id = Id;
        this.Titel = Titel;
        this.Datum = Datum;
        this.Aktiv = Aktiv;
        this.AnzeigeConstraint = AnzeigeConstraint;
        this.Bundeslaender = Bundeslaender;
    }
}

export function News_AdminNewsListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.News.AdminNewsListItem", [], News_AdminNewsListItem, () => [["Id", class_type("System.Guid")], ["Titel", string_type], ["Datum", class_type("System.DateTime")], ["Aktiv", bool_type], ["AnzeigeConstraint", string_type], ["Bundeslaender", list_type(News_BundeslandInfo_$reflection())]]);
}

export class Banner_DesktopImageUploaded extends Record {
    constructor(HasImage, HintergrundFarbe) {
        super();
        this.HasImage = HasImage;
        this.HintergrundFarbe = HintergrundFarbe;
    }
}

export function Banner_DesktopImageUploaded_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Banner.DesktopImageUploaded", [], Banner_DesktopImageUploaded, () => [["HasImage", bool_type], ["HintergrundFarbe", string_type]]);
}

export class Banner_AdminBannerListItem extends Record {
    constructor(Id, Titel, GueltigAb, GueltigBis, Aktiv) {
        super();
        this.Id = Id;
        this.Titel = Titel;
        this.GueltigAb = GueltigAb;
        this.GueltigBis = GueltigBis;
        this.Aktiv = Aktiv;
    }
}

export function Banner_AdminBannerListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Banner.AdminBannerListItem", [], Banner_AdminBannerListItem, () => [["Id", class_type("System.Guid")], ["Titel", string_type], ["GueltigAb", class_type("System.DateTime")], ["GueltigBis", class_type("System.DateTime")], ["Aktiv", bool_type]]);
}

export class Banner_AdminBanner extends Record {
    constructor(Titel, Tag, Text$, HasImageDesktop, HasImageMobile, HintergrundFarbe, TextFarbe, KundenTyp, GueltigAb, GueltigBis, Aktiv, ImageOnly) {
        super();
        this.Titel = Titel;
        this.Tag = Tag;
        this.Text = Text$;
        this.HasImageDesktop = HasImageDesktop;
        this.HasImageMobile = HasImageMobile;
        this.HintergrundFarbe = HintergrundFarbe;
        this.TextFarbe = TextFarbe;
        this.KundenTyp = KundenTyp;
        this.GueltigAb = GueltigAb;
        this.GueltigBis = GueltigBis;
        this.Aktiv = Aktiv;
        this.ImageOnly = ImageOnly;
    }
}

export function Banner_AdminBanner_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Banner.AdminBanner", [], Banner_AdminBanner, () => [["Titel", string_type], ["Tag", string_type], ["Text", string_type], ["HasImageDesktop", bool_type], ["HasImageMobile", bool_type], ["HintergrundFarbe", string_type], ["TextFarbe", string_type], ["KundenTyp", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))], ["GueltigAb", class_type("System.DateTime")], ["GueltigBis", class_type("System.DateTime")], ["Aktiv", bool_type], ["ImageOnly", bool_type]]);
}

export class Banner_Banner extends Record {
    constructor(Id, Titel, Tag, Text$, HasImageDesktop, HasImageMobile, ImageOnly, HintergrundFarbe, TextFarbe) {
        super();
        this.Id = Id;
        this.Titel = Titel;
        this.Tag = Tag;
        this.Text = Text$;
        this.HasImageDesktop = HasImageDesktop;
        this.HasImageMobile = HasImageMobile;
        this.ImageOnly = ImageOnly;
        this.HintergrundFarbe = HintergrundFarbe;
        this.TextFarbe = TextFarbe;
    }
}

export function Banner_Banner_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Banner.Banner", [], Banner_Banner, () => [["Id", class_type("System.Guid")], ["Titel", string_type], ["Tag", string_type], ["Text", string_type], ["HasImageDesktop", bool_type], ["HasImageMobile", bool_type], ["ImageOnly", bool_type], ["HintergrundFarbe", string_type], ["TextFarbe", string_type]]);
}

export class Account_LoginData extends Record {
    constructor(Username, Password, OneTimePassword, NutzungsbedingungenAkzeptiert, Persist) {
        super();
        this.Username = Username;
        this.Password = Password;
        this.OneTimePassword = OneTimePassword;
        this.NutzungsbedingungenAkzeptiert = NutzungsbedingungenAkzeptiert;
        this.Persist = Persist;
    }
}

export function Account_LoginData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.LoginData", [], Account_LoginData, () => [["Username", string_type], ["Password", string_type], ["OneTimePassword", string_type], ["NutzungsbedingungenAkzeptiert", option_type(bool_type)], ["Persist", bool_type]]);
}

export class Account_UserNotifications extends Record {
    constructor(NotificationForBelegeingang, NotificationForBelegpruefungAbgeschlossen, NotificationForAuszahlungGetaetigt, NotificationForPostImPortal, NotificationForPreisInfos, NotificationForTicketAntwort) {
        super();
        this.NotificationForBelegeingang = NotificationForBelegeingang;
        this.NotificationForBelegpruefungAbgeschlossen = NotificationForBelegpruefungAbgeschlossen;
        this.NotificationForAuszahlungGetaetigt = NotificationForAuszahlungGetaetigt;
        this.NotificationForPostImPortal = NotificationForPostImPortal;
        this.NotificationForPreisInfos = NotificationForPreisInfos;
        this.NotificationForTicketAntwort = NotificationForTicketAntwort;
    }
}

export function Account_UserNotifications_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.UserNotifications", [], Account_UserNotifications, () => [["NotificationForBelegeingang", bool_type], ["NotificationForBelegpruefungAbgeschlossen", bool_type], ["NotificationForAuszahlungGetaetigt", bool_type], ["NotificationForPostImPortal", bool_type], ["NotificationForPreisInfos", bool_type], ["NotificationForTicketAntwort", bool_type]]);
}

export class Account_UserInfo extends Record {
    constructor(Kundennummer, OtpEnabeld, Notifications) {
        super();
        this.Kundennummer = Kundennummer;
        this.OtpEnabeld = OtpEnabeld;
        this.Notifications = Notifications;
    }
}

export function Account_UserInfo_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.UserInfo", [], Account_UserInfo, () => [["Kundennummer", option_type(int32_type)], ["OtpEnabeld", bool_type], ["Notifications", Account_UserNotifications_$reflection()]]);
}

export class Account_OtpActivation extends Record {
    constructor(Secret, QrDataUrl) {
        super();
        this.Secret = Secret;
        this.QrDataUrl = QrDataUrl;
    }
}

export function Account_OtpActivation_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.OtpActivation", [], Account_OtpActivation, () => [["Secret", string_type], ["QrDataUrl", string_type]]);
}

export class Account_OtpConfirmation extends Record {
    constructor(Secret, Otp) {
        super();
        this.Secret = Secret;
        this.Otp = Otp;
    }
}

export function Account_OtpConfirmation_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.OtpConfirmation", [], Account_OtpConfirmation, () => [["Secret", string_type], ["Otp", string_type]]);
}

export class Account_ChangePassword extends Record {
    constructor(Password, NewPassword1, NewPassword2) {
        super();
        this.Password = Password;
        this.NewPassword1 = NewPassword1;
        this.NewPassword2 = NewPassword2;
    }
}

export function Account_ChangePassword_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.ChangePassword", [], Account_ChangePassword, () => [["Password", string_type], ["NewPassword1", string_type], ["NewPassword2", string_type]]);
}

export class Account_ResetPassword extends Record {
    constructor(Token, NewPassword1, NewPassword2) {
        super();
        this.Token = Token;
        this.NewPassword1 = NewPassword1;
        this.NewPassword2 = NewPassword2;
    }
}

export function Account_ResetPassword_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.ResetPassword", [], Account_ResetPassword, () => [["Token", string_type], ["NewPassword1", string_type], ["NewPassword2", string_type]]);
}

export class Account_LoginResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoginOk", "UserTemporaryLocked", "OneTimePasswordMissing", "NutzungsbedingungenAkzeptieren", "Wartung", "Unauthorized"];
    }
}

export function Account_LoginResult_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.LoginResult", [], Account_LoginResult, () => [[], [], [], [["Item", string_type]], [["Item", string_type]], []]);
}

export class Account_UserStatus extends Record {
    constructor(Id, Name, Email, Kundennummer, IsNewCustomer, Roles, FirstName, LastName, SprinklrChatHash, SprinklrAppId, IsChatVisible, BeratungsterminUrl) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Email = Email;
        this.Kundennummer = Kundennummer;
        this.IsNewCustomer = IsNewCustomer;
        this.Roles = Roles;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.SprinklrChatHash = SprinklrChatHash;
        this.SprinklrAppId = SprinklrAppId;
        this.IsChatVisible = IsChatVisible;
        this.BeratungsterminUrl = BeratungsterminUrl;
    }
}

export function Account_UserStatus_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Account.UserStatus", [], Account_UserStatus, () => [["Id", string_type], ["Name", string_type], ["Email", string_type], ["Kundennummer", option_type(int32_type)], ["IsNewCustomer", bool_type], ["Roles", list_type(string_type)], ["FirstName", string_type], ["LastName", string_type], ["SprinklrChatHash", string_type], ["SprinklrAppId", string_type], ["IsChatVisible", bool_type], ["BeratungsterminUrl", string_type]]);
}

export class File_FileListItem extends Record {
    constructor(Id, Datum, Titel, Beschreibung, Filename, Kategorie, HasMetadata, Type, IsNew) {
        super();
        this.Id = Id;
        this.Datum = Datum;
        this.Titel = Titel;
        this.Beschreibung = Beschreibung;
        this.Filename = Filename;
        this.Kategorie = Kategorie;
        this.HasMetadata = HasMetadata;
        this.Type = (Type | 0);
        this.IsNew = IsNew;
    }
}

export function File_FileListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.FileListItem", [], File_FileListItem, () => [["Id", class_type("System.Guid")], ["Datum", class_type("System.DateTime")], ["Titel", string_type], ["Beschreibung", string_type], ["Filename", string_type], ["Kategorie", string_type], ["HasMetadata", bool_type], ["Type", enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.FileType", int32_type, [["Csv", 1], ["Pdf", 2], ["File", 3]])], ["IsNew", bool_type]]);
}

export class File_AdminFileListItem extends Record {
    constructor(Id, Datum, Titel, Beschreibung, Filename, Kategorie, HasMetadata, Type, IsHidden, Kundennummer) {
        super();
        this.Id = Id;
        this.Datum = Datum;
        this.Titel = Titel;
        this.Beschreibung = Beschreibung;
        this.Filename = Filename;
        this.Kategorie = Kategorie;
        this.HasMetadata = HasMetadata;
        this.Type = (Type | 0);
        this.IsHidden = IsHidden;
        this.Kundennummer = (Kundennummer | 0);
    }
}

export function File_AdminFileListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.AdminFileListItem", [], File_AdminFileListItem, () => [["Id", class_type("System.Guid")], ["Datum", class_type("System.DateTime")], ["Titel", string_type], ["Beschreibung", string_type], ["Filename", string_type], ["Kategorie", string_type], ["HasMetadata", bool_type], ["Type", enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.File.FileType", int32_type, [["Csv", 1], ["Pdf", 2], ["File", 3]])], ["IsHidden", bool_type], ["Kundennummer", int32_type]]);
}

export class Faq_Faq extends Record {
    constructor(Frage, AntwortHtml) {
        super();
        this.Frage = Frage;
        this.AntwortHtml = AntwortHtml;
    }
}

export function Faq_Faq_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Faq.Faq", [], Faq_Faq, () => [["Frage", string_type], ["AntwortHtml", string_type]]);
}

export class Faq_AdminFaqListItem extends Record {
    constructor(Id, Frage, Position, Aktiv, SichtbarFuerPflege, SichtbarFuerPflegeDtaPlus, SichtbarFuerTherapie, SichtbarFuerJugendhilfe) {
        super();
        this.Id = Id;
        this.Frage = Frage;
        this.Position = (Position | 0);
        this.Aktiv = Aktiv;
        this.SichtbarFuerPflege = SichtbarFuerPflege;
        this.SichtbarFuerPflegeDtaPlus = SichtbarFuerPflegeDtaPlus;
        this.SichtbarFuerTherapie = SichtbarFuerTherapie;
        this.SichtbarFuerJugendhilfe = SichtbarFuerJugendhilfe;
    }
}

export function Faq_AdminFaqListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Faq.AdminFaqListItem", [], Faq_AdminFaqListItem, () => [["Id", class_type("System.Guid")], ["Frage", string_type], ["Position", int32_type], ["Aktiv", bool_type], ["SichtbarFuerPflege", bool_type], ["SichtbarFuerPflegeDtaPlus", bool_type], ["SichtbarFuerTherapie", bool_type], ["SichtbarFuerJugendhilfe", bool_type]]);
}

export class Faq_AdminFaqKategorieListItem extends Record {
    constructor(Id, Anzeigename, Reihenfolge, AnzahlFragen) {
        super();
        this.Id = Id;
        this.Anzeigename = Anzeigename;
        this.Reihenfolge = (Reihenfolge | 0);
        this.AnzahlFragen = (AnzahlFragen | 0);
    }
}

export function Faq_AdminFaqKategorieListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Faq.AdminFaqKategorieListItem", [], Faq_AdminFaqKategorieListItem, () => [["Id", class_type("System.Guid")], ["Anzeigename", string_type], ["Reihenfolge", int32_type], ["AnzahlFragen", int32_type]]);
}

export class Faq_AdminFaq extends Record {
    constructor(Frage, Antwort, Position, Aktiv, SichtbarFuerPflege, SichtbarFuerPflegeDtaPlus, SichtbarFuerTherapie, SichtbarFuerJugendhilfe, KundenportalFaqKategorieId) {
        super();
        this.Frage = Frage;
        this.Antwort = Antwort;
        this.Position = (Position | 0);
        this.Aktiv = Aktiv;
        this.SichtbarFuerPflege = SichtbarFuerPflege;
        this.SichtbarFuerPflegeDtaPlus = SichtbarFuerPflegeDtaPlus;
        this.SichtbarFuerTherapie = SichtbarFuerTherapie;
        this.SichtbarFuerJugendhilfe = SichtbarFuerJugendhilfe;
        this.KundenportalFaqKategorieId = KundenportalFaqKategorieId;
    }
}

export function Faq_AdminFaq_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Faq.AdminFaq", [], Faq_AdminFaq, () => [["Frage", string_type], ["Antwort", string_type], ["Position", int32_type], ["Aktiv", bool_type], ["SichtbarFuerPflege", bool_type], ["SichtbarFuerPflegeDtaPlus", bool_type], ["SichtbarFuerTherapie", bool_type], ["SichtbarFuerJugendhilfe", bool_type], ["KundenportalFaqKategorieId", class_type("System.Guid")]]);
}

export class Dta_DtaListItem extends Record {
    constructor(Id, Dateiname, Hochgeladen, StatusTyp, Statusmeldung) {
        super();
        this.Id = Id;
        this.Dateiname = Dateiname;
        this.Hochgeladen = Hochgeladen;
        this.StatusTyp = (StatusTyp | 0);
        this.Statusmeldung = Statusmeldung;
    }
}

export function Dta_DtaListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dta.DtaListItem", [], Dta_DtaListItem, () => [["Id", class_type("System.Guid")], ["Dateiname", string_type], ["Hochgeladen", class_type("System.DateTime")], ["StatusTyp", int32_type], ["Statusmeldung", string_type]]);
}

export class Help_NeuesTicket extends Record {
    constructor(Betreff, Text$, Attachments, RechnungId, KundenportalTicketKategorieId) {
        super();
        this.Betreff = Betreff;
        this.Text = Text$;
        this.Attachments = Attachments;
        this.RechnungId = RechnungId;
        this.KundenportalTicketKategorieId = (KundenportalTicketKategorieId | 0);
    }
}

export function Help_NeuesTicket_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Help.NeuesTicket", [], Help_NeuesTicket, () => [["Betreff", string_type], ["Text", string_type], ["Attachments", list_type(class_type("System.Guid"))], ["RechnungId", option_type(class_type("System.Guid"))], ["KundenportalTicketKategorieId", int32_type]]);
}

export class Help_UserTicketAntwort extends Record {
    constructor(Text$, IsNew) {
        super();
        this.Text = Text$;
        this.IsNew = IsNew;
    }
}

export function Help_UserTicketAntwort_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Help.UserTicketAntwort", [], Help_UserTicketAntwort, () => [["Text", string_type], ["IsNew", bool_type]]);
}

export class Help_UserTicketListItem extends Record {
    constructor(Nummer, Datum, IstErledigt, Betreff, Text$, Antworten, Attachments, TicketId, AbsetzungImportNummer, AufgabeNummer) {
        super();
        this.Nummer = Nummer;
        this.Datum = Datum;
        this.IstErledigt = IstErledigt;
        this.Betreff = Betreff;
        this.Text = Text$;
        this.Antworten = Antworten;
        this.Attachments = Attachments;
        this.TicketId = TicketId;
        this.AbsetzungImportNummer = AbsetzungImportNummer;
        this.AufgabeNummer = AufgabeNummer;
    }
}

export function Help_UserTicketListItem_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Help.UserTicketListItem", [], Help_UserTicketListItem, () => [["Nummer", option_type(int32_type)], ["Datum", class_type("System.DateTime")], ["IstErledigt", bool_type], ["Betreff", string_type], ["Text", string_type], ["Antworten", list_type(Help_UserTicketAntwort_$reflection())], ["Attachments", option_type(string_type)], ["TicketId", class_type("System.Guid")], ["AbsetzungImportNummer", option_type(int32_type)], ["AufgabeNummer", option_type(int32_type)]]);
}

export class Help_KundenportalTicketKategorie extends Record {
    constructor(Id, Bezeichnung) {
        super();
        this.Id = (Id | 0);
        this.Bezeichnung = Bezeichnung;
    }
}

export function Help_KundenportalTicketKategorie_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Help.KundenportalTicketKategorie", [], Help_KundenportalTicketKategorie, () => [["Id", int32_type], ["Bezeichnung", string_type]]);
}

export class Help_Ansprechpartner extends Record {
    constructor(Ueberschrift, Text$, Telefon, ImageUrl) {
        super();
        this.Ueberschrift = Ueberschrift;
        this.Text = Text$;
        this.Telefon = Telefon;
        this.ImageUrl = ImageUrl;
    }
}

export function Help_Ansprechpartner_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Help.Ansprechpartner", [], Help_Ansprechpartner, () => [["Ueberschrift", string_type], ["Text", string_type], ["Telefon", string_type], ["ImageUrl", option_type(string_type)]]);
}

export const Help_sizeLimitMB = 3;

export class Admin_AdminInfos$1 extends Record {
    constructor(Id, Item, HasImage) {
        super();
        this.Id = Id;
        this.Item = Item;
        this.HasImage = HasImage;
    }
}

export function Admin_AdminInfos$1_$reflection(gen0) {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Admin.AdminInfos`1", [gen0], Admin_AdminInfos$1, () => [["Id", class_type("System.Guid")], ["Item", gen0], ["HasImage", bool_type]]);
}

export class Verrechnungen_Filiale extends Record {
    constructor(FilialeId, Name, IsZentrale, Limit) {
        super();
        this.FilialeId = FilialeId;
        this.Name = Name;
        this.IsZentrale = IsZentrale;
        this.Limit = Limit;
    }
}

export function Verrechnungen_Filiale_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Verrechnungen.Filiale", [], Verrechnungen_Filiale, () => [["FilialeId", class_type("System.Guid")], ["Name", string_type], ["IsZentrale", bool_type], ["Limit", decimal_type]]);
}

export class Verrechnungen_Ticket extends Record {
    constructor(TicketId, Datum, Betreff, IstErledigt, HatAntworten) {
        super();
        this.TicketId = TicketId;
        this.Datum = Datum;
        this.Betreff = Betreff;
        this.IstErledigt = IstErledigt;
        this.HatAntworten = HatAntworten;
    }
}

export function Verrechnungen_Ticket_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Verrechnungen.Ticket", [], Verrechnungen_Ticket, () => [["TicketId", class_type("System.Guid")], ["Datum", class_type("System.DateTime")], ["Betreff", string_type], ["IstErledigt", bool_type], ["HatAntworten", bool_type]]);
}

export class Verrechnungen_Verrechnung extends Record {
    constructor(ForderungId, Status, Faelligkeitsdatum, RechnugnsNr, KlientVorname, KlientNachname, Absetzungsgrund, Details, Rechnungsbetrag, Betrag, RechnungId, Tickets, Ankaufdatum) {
        super();
        this.ForderungId = ForderungId;
        this.Status = (Status | 0);
        this.Faelligkeitsdatum = Faelligkeitsdatum;
        this.RechnugnsNr = RechnugnsNr;
        this.KlientVorname = KlientVorname;
        this.KlientNachname = KlientNachname;
        this.Absetzungsgrund = Absetzungsgrund;
        this.Details = Details;
        this.Rechnungsbetrag = Rechnungsbetrag;
        this.Betrag = Betrag;
        this.RechnungId = RechnungId;
        this.Tickets = Tickets;
        this.Ankaufdatum = Ankaufdatum;
    }
}

export function Verrechnungen_Verrechnung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Verrechnungen.Verrechnung", [], Verrechnungen_Verrechnung, () => [["ForderungId", class_type("System.Guid")], ["Status", enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Verrechnungen.Verschiebungsstatus", int32_type, [["VerschiebungMoeglich", 1], ["ForderungTerminiert", 2], ["ForderungFaellig", 3], ["BereitsVerschoben", 4]])], ["Faelligkeitsdatum", class_type("System.DateTime")], ["RechnugnsNr", string_type], ["KlientVorname", string_type], ["KlientNachname", string_type], ["Absetzungsgrund", string_type], ["Details", string_type], ["Rechnungsbetrag", decimal_type], ["Betrag", decimal_type], ["RechnungId", class_type("System.Guid")], ["Tickets", array_type(Verrechnungen_Ticket_$reflection())], ["Ankaufdatum", class_type("System.DateTime")]]);
}

export class Verrechnungen_VerschiebungResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VerschiebungNichtMoeglichError", "VerschiebungNichtMoeglichLimitErreicht", "VerschiebungOk"];
    }
}

export function Verrechnungen_VerschiebungResult_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Verrechnungen.VerschiebungResult", [], Verrechnungen_VerschiebungResult, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class UserManagement_UserManagedRole extends Record {
    constructor(KundenportalRolleId, Name, Bezeichnung, Beschreibung) {
        super();
        this.KundenportalRolleId = (KundenportalRolleId | 0);
        this.Name = Name;
        this.Bezeichnung = Bezeichnung;
        this.Beschreibung = Beschreibung;
    }
}

export function UserManagement_UserManagedRole_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.UserManagement.UserManagedRole", [], UserManagement_UserManagedRole, () => [["KundenportalRolleId", int32_type], ["Name", string_type], ["Bezeichnung", string_type], ["Beschreibung", string_type]]);
}

export class UserManagement_UserCreationData extends Record {
    constructor(Email, Name, ManagedRoles) {
        super();
        this.Email = Email;
        this.Name = Name;
        this.ManagedRoles = ManagedRoles;
    }
}

export function UserManagement_UserCreationData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.UserManagement.UserCreationData", [], UserManagement_UserCreationData, () => [["Email", string_type], ["Name", string_type], ["ManagedRoles", list_type(UserManagement_UserManagedRole_$reflection())]]);
}

export class UserManagement_UserInfo extends Record {
    constructor(KundenportalBenutzerId, Login, Email, Name, BenutzerverwalteteRollen, Nutzt2Fa, LetzterLogin, Gesperrt, IsCurrentUser) {
        super();
        this.KundenportalBenutzerId = (KundenportalBenutzerId | 0);
        this.Login = Login;
        this.Email = Email;
        this.Name = Name;
        this.BenutzerverwalteteRollen = BenutzerverwalteteRollen;
        this.Nutzt2Fa = Nutzt2Fa;
        this.LetzterLogin = LetzterLogin;
        this.Gesperrt = Gesperrt;
        this.IsCurrentUser = IsCurrentUser;
    }
}

export function UserManagement_UserInfo_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.UserManagement.UserInfo", [], UserManagement_UserInfo, () => [["KundenportalBenutzerId", int32_type], ["Login", string_type], ["Email", string_type], ["Name", string_type], ["BenutzerverwalteteRollen", list_type(UserManagement_UserManagedRole_$reflection())], ["Nutzt2Fa", bool_type], ["LetzterLogin", option_type(class_type("System.DateTime"))], ["Gesperrt", bool_type], ["IsCurrentUser", bool_type]]);
}

export class UserManagement_UpdateUserData extends Record {
    constructor(KundenportalBenutzerId, Login, Name, Email, Roles) {
        super();
        this.KundenportalBenutzerId = (KundenportalBenutzerId | 0);
        this.Login = Login;
        this.Name = Name;
        this.Email = Email;
        this.Roles = Roles;
    }
}

export function UserManagement_UpdateUserData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.UserManagement.UpdateUserData", [], UserManagement_UpdateUserData, () => [["KundenportalBenutzerId", int32_type], ["Login", string_type], ["Name", string_type], ["Email", string_type], ["Roles", list_type(UserManagement_UserManagedRole_$reflection())]]);
}

export class UserManagement_PasswordResetData extends Record {
    constructor(KundenportalBenutzerId, Email) {
        super();
        this.KundenportalBenutzerId = (KundenportalBenutzerId | 0);
        this.Email = Email;
    }
}

export function UserManagement_PasswordResetData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.UserManagement.PasswordResetData", [], UserManagement_PasswordResetData, () => [["KundenportalBenutzerId", int32_type], ["Email", string_type]]);
}

export class Quickfinder_DownloadType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoDownload", "WithDownloadDokumentAnfrage", "WithDownloadSammelrechnung", "WithDownloadButFlatrateNeeded"];
    }
}

export function Quickfinder_DownloadType_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.DownloadType", [], Quickfinder_DownloadType, () => [[], [["linkName", string_type], ["dokumentAnfrageId", class_type("System.Guid")]], [["linkName", string_type], ["sammelrechnungId", class_type("System.Guid")]], [["linkName", string_type]]]);
}

export class Quickfinder_QuickFinderIcon extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Sanduhr", "Eingang", "KassePlus", "KasseMinus", "Achtung", "Hinweis", "Geld", "Aktion", "Ticket"];
    }
}

export function Quickfinder_QuickFinderIcon_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.QuickFinderIcon", [], Quickfinder_QuickFinderIcon, () => [[], [], [], [], [], [], [], [], []]);
}

export function Quickfinder_QuickFinderIcon__ToCssIcon(this$) {
    return "icon-" + ((this$.tag === 1) ? "eingang" : ((this$.tag === 2) ? "kasse-plus" : ((this$.tag === 3) ? "kasse-minus" : ((this$.tag === 4) ? "achtung" : ((this$.tag === 5) ? "hinweis" : ((this$.tag === 6) ? "geld" : ((this$.tag === 7) ? "aktion" : ((this$.tag === 8) ? "ticket" : "sanduhr"))))))));
}

export class Quickfinder_Information extends Record {
    constructor(Datum, Reihenfolge, Icon, LegacyIcon, Typ, Text$, Hilfetext, Download, RechnungId, TicketId) {
        super();
        this.Datum = Datum;
        this.Reihenfolge = (Reihenfolge | 0);
        this.Icon = Icon;
        this.LegacyIcon = LegacyIcon;
        this.Typ = Typ;
        this.Text = Text$;
        this.Hilfetext = Hilfetext;
        this.Download = Download;
        this.RechnungId = RechnungId;
        this.TicketId = TicketId;
    }
}

export function Quickfinder_Information_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.Information", [], Quickfinder_Information, () => [["Datum", class_type("System.DateTime")], ["Reihenfolge", int32_type], ["Icon", option_type(Quickfinder_QuickFinderIcon_$reflection())], ["LegacyIcon", string_type], ["Typ", string_type], ["Text", string_type], ["Hilfetext", option_type(string_type)], ["Download", Quickfinder_DownloadType_$reflection()], ["RechnungId", option_type(class_type("System.Guid"))], ["TicketId", option_type(class_type("System.Guid"))]]);
}

export function Quickfinder_Information_get_NoInformation() {
    return new Quickfinder_Information(create(1, 1, 1), 0, undefined, "", "", "", undefined, new Quickfinder_DownloadType(0, []), undefined, undefined);
}

export class Quickfinder_RechnungInfo extends Record {
    constructor(RechnungId, SendungsNr, Rechnungsdatum, Klient, Empfaenger, Betrag) {
        super();
        this.RechnungId = RechnungId;
        this.SendungsNr = (SendungsNr | 0);
        this.Rechnungsdatum = Rechnungsdatum;
        this.Klient = Klient;
        this.Empfaenger = Empfaenger;
        this.Betrag = Betrag;
    }
}

export function Quickfinder_RechnungInfo_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.RechnungInfo", [], Quickfinder_RechnungInfo, () => [["RechnungId", class_type("System.Guid")], ["SendungsNr", int32_type], ["Rechnungsdatum", class_type("System.DateTime")], ["Klient", string_type], ["Empfaenger", string_type], ["Betrag", decimal_type]]);
}

export class Quickfinder_QuickfinderResponse extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Informationen", "RechnungenSelect"];
    }
}

export function Quickfinder_QuickfinderResponse_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Quickfinder.QuickfinderResponse", [], Quickfinder_QuickfinderResponse, () => [[["Item", list_type(Quickfinder_Information_$reflection())]], [["Item", list_type(Quickfinder_RechnungInfo_$reflection())]]]);
}

export class Settings_DokumentenabrufStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Inaktiv", "Probezeit", "Gebuehrenpflichtig"];
    }
}

export function Settings_DokumentenabrufStatus_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Settings.DokumentenabrufStatus", [], Settings_DokumentenabrufStatus, () => [[], [], []]);
}

export class Settings_DokumentenabrufSettings extends Record {
    constructor(FilialeId, Name1, Name2, GueltigBis, DokumentenabrufStatus) {
        super();
        this.FilialeId = FilialeId;
        this.Name1 = Name1;
        this.Name2 = Name2;
        this.GueltigBis = GueltigBis;
        this.DokumentenabrufStatus = DokumentenabrufStatus;
    }
}

export function Settings_DokumentenabrufSettings_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Settings.DokumentenabrufSettings", [], Settings_DokumentenabrufSettings, () => [["FilialeId", class_type("System.Guid")], ["Name1", string_type], ["Name2", string_type], ["GueltigBis", option_type(class_type("System.DateTime"))], ["DokumentenabrufStatus", Settings_DokumentenabrufStatus_$reflection()]]);
}

export class Settings_Settings extends Record {
    constructor(DokumentenabrufSettings) {
        super();
        this.DokumentenabrufSettings = DokumentenabrufSettings;
    }
}

export function Settings_Settings_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Settings.Settings", [], Settings_Settings, () => [["DokumentenabrufSettings", array_type(Settings_DokumentenabrufSettings_$reflection())]]);
}

export class Settings_ISettingsService extends Record {
    constructor(GetSettings, TryDokumentenabruf, SetDokumentenabruf) {
        super();
        this.GetSettings = GetSettings;
        this.TryDokumentenabruf = TryDokumentenabruf;
        this.SetDokumentenabruf = SetDokumentenabruf;
    }
}

export function Settings_ISettingsService_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Settings.ISettingsService", [], Settings_ISettingsService, () => [["GetSettings", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [Settings_Settings_$reflection()]))], ["TryDokumentenabruf", lambda_type(tuple_type(class_type("System.Guid"), bool_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))], ["SetDokumentenabruf", lambda_type(tuple_type(class_type("System.Guid"), bool_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]))]]);
}

export class ApiToken_Token extends Record {
    constructor(Id, Erstellt, LetzteNutzung) {
        super();
        this.Id = (Id | 0);
        this.Erstellt = Erstellt;
        this.LetzteNutzung = LetzteNutzung;
    }
}

export function ApiToken_Token_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ApiToken.Token", [], ApiToken_Token, () => [["Id", int32_type], ["Erstellt", class_type("System.DateTime")], ["LetzteNutzung", option_type(class_type("System.DateTime"))]]);
}

export class ApiToken_Filiale extends Record {
    constructor(Id, Name, IsZentrale, Tokens) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.IsZentrale = IsZentrale;
        this.Tokens = Tokens;
    }
}

export function ApiToken_Filiale_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ApiToken.Filiale", [], ApiToken_Filiale, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["IsZentrale", bool_type], ["Tokens", list_type(ApiToken_Token_$reflection())]]);
}

export class ApiToken_CreateTokenResult extends Record {
    constructor(Id, FilialeId, Value, Erstellt) {
        super();
        this.Id = (Id | 0);
        this.FilialeId = FilialeId;
        this.Value = Value;
        this.Erstellt = Erstellt;
    }
}

export function ApiToken_CreateTokenResult_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ApiToken.CreateTokenResult", [], ApiToken_CreateTokenResult, () => [["Id", int32_type], ["FilialeId", class_type("System.Guid")], ["Value", string_type], ["Erstellt", class_type("System.DateTime")]]);
}

export class Sendungen_Filiale extends Record {
    constructor(FilialeId, Name, IsZentrale) {
        super();
        this.FilialeId = FilialeId;
        this.Name = Name;
        this.IsZentrale = IsZentrale;
    }
}

export function Sendungen_Filiale_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.Filiale", [], Sendungen_Filiale, () => [["FilialeId", class_type("System.Guid")], ["Name", string_type], ["IsZentrale", bool_type]]);
}

export class Sendungen_SendungsOption extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Papierlos", "Mischsendung", "DokumentenDepot", "Beleglos"];
    }
}

export function Sendungen_SendungsOption_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.SendungsOption", [], Sendungen_SendungsOption, () => [[], [], [], []]);
}

export class Sendungen_Sendung extends Record {
    constructor(SendungId, SendungsNr, ErwartetesZahldatum, Belegeingang, Belegpruefung, Gesamtbetrag, Angekauft, AllowDokumentenDepot, AllowUploads, AllowFlexitarif, SendungsOption, TarifGewaehlt) {
        super();
        this.SendungId = SendungId;
        this.SendungsNr = (SendungsNr | 0);
        this.ErwartetesZahldatum = ErwartetesZahldatum;
        this.Belegeingang = Belegeingang;
        this.Belegpruefung = Belegpruefung;
        this.Gesamtbetrag = Gesamtbetrag;
        this.Angekauft = Angekauft;
        this.AllowDokumentenDepot = AllowDokumentenDepot;
        this.AllowUploads = AllowUploads;
        this.AllowFlexitarif = AllowFlexitarif;
        this.SendungsOption = SendungsOption;
        this.TarifGewaehlt = TarifGewaehlt;
    }
}

export function Sendungen_Sendung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.Sendung", [], Sendungen_Sendung, () => [["SendungId", class_type("System.Guid")], ["SendungsNr", int32_type], ["ErwartetesZahldatum", option_type(class_type("System.DateTime"))], ["Belegeingang", option_type(class_type("System.DateTime"))], ["Belegpruefung", option_type(class_type("System.DateTime"))], ["Gesamtbetrag", option_type(decimal_type)], ["Angekauft", option_type(decimal_type)], ["AllowDokumentenDepot", bool_type], ["AllowUploads", bool_type], ["AllowFlexitarif", bool_type], ["SendungsOption", option_type(Sendungen_SendungsOption_$reflection())], ["TarifGewaehlt", bool_type]]);
}

export class Sendungen_SendungsOptionData extends Record {
    constructor(SendungId, SendungsOption, DateiIds) {
        super();
        this.SendungId = SendungId;
        this.SendungsOption = SendungsOption;
        this.DateiIds = DateiIds;
    }
}

export function Sendungen_SendungsOptionData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.SendungsOptionData", [], Sendungen_SendungsOptionData, () => [["SendungId", class_type("System.Guid")], ["SendungsOption", Sendungen_SendungsOption_$reflection()], ["DateiIds", list_type(class_type("System.Guid"))]]);
}

export class Sendungen_FlexitarifEntgelt extends Record {
    constructor(Auszahlungstag, Entgelt) {
        super();
        this.Auszahlungstag = Auszahlungstag;
        this.Entgelt = Entgelt;
    }
}

export function Sendungen_FlexitarifEntgelt_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.FlexitarifEntgelt", [], Sendungen_FlexitarifEntgelt, () => [["Auszahlungstag", class_type("System.DateTime")], ["Entgelt", decimal_type]]);
}

export class Sendungen_Belegeingang extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Stored", "Calculated"];
    }
}

export function Sendungen_Belegeingang_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.Belegeingang", [], Sendungen_Belegeingang, () => [[["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]]]);
}

export function Sendungen_Belegeingang__get_Value(this$) {
    if (this$.tag === 1) {
        return this$.fields[0];
    }
    else {
        return this$.fields[0];
    }
}

export class Sendungen_FlexitarifFuerSendung extends Record {
    constructor(SendungId, SendungsNr, ForderungsVolumen, EntgeltFuerVorziehung, Belegeingang, BelegeingangErfasst, VereinbartesZahlungsziel, KalkuliertesZahlungsdatum, AuszahlungstageMitEntgelt, SicherheitsguthabenProzent, SicherheitsguthabenBetrag, Agb) {
        super();
        this.SendungId = SendungId;
        this.SendungsNr = (SendungsNr | 0);
        this.ForderungsVolumen = ForderungsVolumen;
        this.EntgeltFuerVorziehung = EntgeltFuerVorziehung;
        this.Belegeingang = Belegeingang;
        this.BelegeingangErfasst = BelegeingangErfasst;
        this.VereinbartesZahlungsziel = (VereinbartesZahlungsziel | 0);
        this.KalkuliertesZahlungsdatum = KalkuliertesZahlungsdatum;
        this.AuszahlungstageMitEntgelt = AuszahlungstageMitEntgelt;
        this.SicherheitsguthabenProzent = SicherheitsguthabenProzent;
        this.SicherheitsguthabenBetrag = SicherheitsguthabenBetrag;
        this.Agb = Agb;
    }
}

export function Sendungen_FlexitarifFuerSendung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.FlexitarifFuerSendung", [], Sendungen_FlexitarifFuerSendung, () => [["SendungId", class_type("System.Guid")], ["SendungsNr", int32_type], ["ForderungsVolumen", decimal_type], ["EntgeltFuerVorziehung", decimal_type], ["Belegeingang", Sendungen_Belegeingang_$reflection()], ["BelegeingangErfasst", bool_type], ["VereinbartesZahlungsziel", int32_type], ["KalkuliertesZahlungsdatum", class_type("System.DateTime")], ["AuszahlungstageMitEntgelt", array_type(Sendungen_FlexitarifEntgelt_$reflection())], ["SicherheitsguthabenProzent", decimal_type], ["SicherheitsguthabenBetrag", decimal_type], ["Agb", string_type]]);
}

export class Sendungen_FlexitarifAuswahl extends Record {
    constructor(AusfuehrungZahlung) {
        super();
        this.AusfuehrungZahlung = AusfuehrungZahlung;
    }
}

export function Sendungen_FlexitarifAuswahl_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.FlexitarifAuswahl", [], Sendungen_FlexitarifAuswahl, () => [["AusfuehrungZahlung", class_type("System.DateTime")]]);
}

export class Sendungen_FlexitarifResult extends Record {
    constructor(SendungsNr, AusfuehrungZahlung, Entgelt) {
        super();
        this.SendungsNr = (SendungsNr | 0);
        this.AusfuehrungZahlung = AusfuehrungZahlung;
        this.Entgelt = Entgelt;
    }
}

export function Sendungen_FlexitarifResult_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sendungen.FlexitarifResult", [], Sendungen_FlexitarifResult, () => [["SendungsNr", int32_type], ["AusfuehrungZahlung", class_type("System.DateTime")], ["Entgelt", decimal_type]]);
}

export class Dashboard_LetzteSendung extends Record {
    constructor(SendungsNummer, SendungsStatus, Gesamtvolumen, Angekauft, NichtAngekauft) {
        super();
        this.SendungsNummer = (SendungsNummer | 0);
        this.SendungsStatus = SendungsStatus;
        this.Gesamtvolumen = Gesamtvolumen;
        this.Angekauft = Angekauft;
        this.NichtAngekauft = NichtAngekauft;
    }
}

export function Dashboard_LetzteSendung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.LetzteSendung", [], Dashboard_LetzteSendung, () => [["SendungsNummer", int32_type], ["SendungsStatus", string_type], ["Gesamtvolumen", decimal_type], ["Angekauft", option_type(decimal_type)], ["NichtAngekauft", option_type(decimal_type)]]);
}

export class Dashboard_MeineLetzteSendung extends Record {
    constructor(LetzteSendung, Benachrichtigung) {
        super();
        this.LetzteSendung = LetzteSendung;
        this.Benachrichtigung = Benachrichtigung;
    }
}

export function Dashboard_MeineLetzteSendung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.MeineLetzteSendung", [], Dashboard_MeineLetzteSendung, () => [["LetzteSendung", option_type(Dashboard_LetzteSendung_$reflection())], ["Benachrichtigung", bool_type]]);
}

export class Dashboard_AnstehendeZahlung extends Record {
    constructor(Betrag, Datum, Benachrichtigung) {
        super();
        this.Betrag = Betrag;
        this.Datum = Datum;
        this.Benachrichtigung = Benachrichtigung;
    }
}

export function Dashboard_AnstehendeZahlung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.AnstehendeZahlung", [], Dashboard_AnstehendeZahlung, () => [["Betrag", option_type(decimal_type)], ["Datum", option_type(class_type("System.DateTime"))], ["Benachrichtigung", bool_type]]);
}

export class Dashboard_LetzterBelegeingangSendung extends Record {
    constructor(SendungsNummer, Datum, Status) {
        super();
        this.SendungsNummer = (SendungsNummer | 0);
        this.Datum = Datum;
        this.Status = Status;
    }
}

export function Dashboard_LetzterBelegeingangSendung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.LetzterBelegeingangSendung", [], Dashboard_LetzterBelegeingangSendung, () => [["SendungsNummer", int32_type], ["Datum", class_type("System.DateTime")], ["Status", string_type]]);
}

export class Dashboard_LetzterBelegeingang extends Record {
    constructor(Sendungen, Benachrichtigung) {
        super();
        this.Sendungen = Sendungen;
        this.Benachrichtigung = Benachrichtigung;
    }
}

export function Dashboard_LetzterBelegeingang_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.LetzterBelegeingang", [], Dashboard_LetzterBelegeingang, () => [["Sendungen", list_type(Dashboard_LetzterBelegeingangSendung_$reflection())], ["Benachrichtigung", bool_type]]);
}

export class Dashboard_MeineZahlen extends Record {
    constructor(Volumen, Zahlungen, Monat, IstLetztesJahr) {
        super();
        this.Volumen = Volumen;
        this.Zahlungen = Zahlungen;
        this.Monat = Monat;
        this.IstLetztesJahr = IstLetztesJahr;
    }
}

export function Dashboard_MeineZahlen_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.MeineZahlen", [], Dashboard_MeineZahlen, () => [["Volumen", decimal_type], ["Zahlungen", decimal_type], ["Monat", string_type], ["IstLetztesJahr", bool_type]]);
}

export class Dashboard_DigitaleKundenrechnung extends Record {
    constructor(DigitaleKundenrechnungAktiviert) {
        super();
        this.DigitaleKundenrechnungAktiviert = DigitaleKundenrechnungAktiviert;
    }
}

export function Dashboard_DigitaleKundenrechnung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.DigitaleKundenrechnung", [], Dashboard_DigitaleKundenrechnung, () => [["DigitaleKundenrechnungAktiviert", bool_type]]);
}

export class Dashboard_Chats extends Record {
    constructor(ChatsAnzahl, ChatsBewertung, ChatsBewertungsMonat) {
        super();
        this.ChatsAnzahl = (ChatsAnzahl | 0);
        this.ChatsBewertung = ChatsBewertung;
        this.ChatsBewertungsMonat = ChatsBewertungsMonat;
    }
}

export function Dashboard_Chats_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Chats", [], Dashboard_Chats, () => [["ChatsAnzahl", int32_type], ["ChatsBewertung", decimal_type], ["ChatsBewertungsMonat", string_type]]);
}

export class Dashboard_Tickets extends Record {
    constructor(TicketsAnzahlAllTimesInsgesamt, TicketsAnzahlAllTimesErledigt, Monat) {
        super();
        this.TicketsAnzahlAllTimesInsgesamt = (TicketsAnzahlAllTimesInsgesamt | 0);
        this.TicketsAnzahlAllTimesErledigt = (TicketsAnzahlAllTimesErledigt | 0);
        this.Monat = Monat;
    }
}

export function Dashboard_Tickets_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Tickets", [], Dashboard_Tickets, () => [["TicketsAnzahlAllTimesInsgesamt", int32_type], ["TicketsAnzahlAllTimesErledigt", int32_type], ["Monat", string_type]]);
}

export class Dashboard_DokumentenDepot extends Record {
    constructor(Absetzungen, NichtAnkaeufe, Einlagerungen, NaechsteRuecksendung) {
        super();
        this.Absetzungen = (Absetzungen | 0);
        this.NichtAnkaeufe = (NichtAnkaeufe | 0);
        this.Einlagerungen = (Einlagerungen | 0);
        this.NaechsteRuecksendung = NaechsteRuecksendung;
    }
}

export function Dashboard_DokumentenDepot_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.DokumentenDepot", [], Dashboard_DokumentenDepot, () => [["Absetzungen", int32_type], ["NichtAnkaeufe", int32_type], ["Einlagerungen", int32_type], ["NaechsteRuecksendung", option_type(class_type("System.DateTime"))]]);
}

export class Dashboard_NeueDokumente extends Record {
    constructor(Benachrichtigung) {
        super();
        this.Benachrichtigung = Benachrichtigung;
    }
}

export function Dashboard_NeueDokumente_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.NeueDokumente", [], Dashboard_NeueDokumente, () => [["Benachrichtigung", bool_type]]);
}

export class Dashboard_ClickLogEntry extends Record {
    constructor(Component, Object$) {
        super();
        this.Component = Component;
        this.Object = Object$;
    }
}

export function Dashboard_ClickLogEntry_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.ClickLogEntry", [], Dashboard_ClickLogEntry, () => [["Component", string_type], ["Object", string_type]]);
}

export class Dashboard_ToggleNotificationRequest extends Record {
    constructor(Enabled) {
        super();
        this.Enabled = Enabled;
    }
}

export function Dashboard_ToggleNotificationRequest_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.ToggleNotificationRequest", [], Dashboard_ToggleNotificationRequest, () => [["Enabled", bool_type]]);
}

export class Dashboard_VertragBestaetigung extends Record {
    constructor(VertragsNummer, VertragsBeschreibung, VertragsText, VertragsTeaser) {
        super();
        this.VertragsNummer = VertragsNummer;
        this.VertragsBeschreibung = VertragsBeschreibung;
        this.VertragsText = VertragsText;
        this.VertragsTeaser = VertragsTeaser;
    }
}

export function Dashboard_VertragBestaetigung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.VertragBestaetigung", [], Dashboard_VertragBestaetigung, () => [["VertragsNummer", string_type], ["VertragsBeschreibung", string_type], ["VertragsText", string_type], ["VertragsTeaser", string_type]]);
}

export class Dashboard_VertragBestaetigungRequest extends Record {
    constructor(VertragsNummer, Name) {
        super();
        this.VertragsNummer = VertragsNummer;
        this.Name = Name;
    }
}

export function Dashboard_VertragBestaetigungRequest_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.VertragBestaetigungRequest", [], Dashboard_VertragBestaetigungRequest, () => [["VertragsNummer", string_type], ["Name", string_type]]);
}

export class Dashboard_Bankverbindung extends Record {
    constructor(BankverbindungBestaetigungId, BankverbindungId, Filialname, Institutsname, Kontoinhaber, Iban, Bic) {
        super();
        this.BankverbindungBestaetigungId = BankverbindungBestaetigungId;
        this.BankverbindungId = BankverbindungId;
        this.Filialname = Filialname;
        this.Institutsname = Institutsname;
        this.Kontoinhaber = Kontoinhaber;
        this.Iban = Iban;
        this.Bic = Bic;
    }
}

export function Dashboard_Bankverbindung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Bankverbindung", [], Dashboard_Bankverbindung, () => [["BankverbindungBestaetigungId", class_type("System.Guid")], ["BankverbindungId", class_type("System.Guid")], ["Filialname", string_type], ["Institutsname", string_type], ["Kontoinhaber", option_type(string_type)], ["Iban", option_type(string_type)], ["Bic", option_type(string_type)]]);
}

export class Dashboard_BannerType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoBanner", "UserBanner", "AdminBanner", "Confirmation"];
    }
}

export function Dashboard_BannerType_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.BannerType", [], Dashboard_BannerType, () => [[], [], [["Item", list_type(Dashboard_Bankverbindung_$reflection())]], []]);
}

export class Dashboard_SetBankverbindungBestaetigung extends Record {
    constructor(BankverbindungBestaetigungId, Institutsname, Kontoinhaber, IBAN, BIC, BestaetigtAm, Korrigiert) {
        super();
        this.BankverbindungBestaetigungId = BankverbindungBestaetigungId;
        this.Institutsname = Institutsname;
        this.Kontoinhaber = Kontoinhaber;
        this.IBAN = IBAN;
        this.BIC = BIC;
        this.BestaetigtAm = BestaetigtAm;
        this.Korrigiert = Korrigiert;
    }
}

export function Dashboard_SetBankverbindungBestaetigung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.SetBankverbindungBestaetigung", [], Dashboard_SetBankverbindungBestaetigung, () => [["BankverbindungBestaetigungId", class_type("System.Guid")], ["Institutsname", string_type], ["Kontoinhaber", string_type], ["IBAN", string_type], ["BIC", string_type], ["BestaetigtAm", class_type("System.DateTime")], ["Korrigiert", bool_type]]);
}

export class Dashboard_Lists_SendungBelegeingang extends Record {
    constructor(SendungNr, AnzahlBelege, Status, Zeitstempel) {
        super();
        this.SendungNr = (SendungNr | 0);
        this.AnzahlBelege = (AnzahlBelege | 0);
        this.Status = Status;
        this.Zeitstempel = Zeitstempel;
    }
}

export function Dashboard_Lists_SendungBelegeingang_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.SendungBelegeingang", [], Dashboard_Lists_SendungBelegeingang, () => [["SendungNr", int32_type], ["AnzahlBelege", int32_type], ["Status", string_type], ["Zeitstempel", option_type(class_type("System.DateTime"))]]);
}

export class Dashboard_Lists_SendungBelegeDetails extends Record {
    constructor(KlientPatient, RechnungsNrExtern, LeistungsGrundlage, Rechnungsbetrag, Meldung) {
        super();
        this.KlientPatient = KlientPatient;
        this.RechnungsNrExtern = RechnungsNrExtern;
        this.LeistungsGrundlage = LeistungsGrundlage;
        this.Rechnungsbetrag = Rechnungsbetrag;
        this.Meldung = Meldung;
    }
}

export function Dashboard_Lists_SendungBelegeDetails_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.SendungBelegeDetails", [], Dashboard_Lists_SendungBelegeDetails, () => [["KlientPatient", string_type], ["RechnungsNrExtern", string_type], ["LeistungsGrundlage", string_type], ["Rechnungsbetrag", decimal_type], ["Meldung", string_type]]);
}

export class Dashboard_Lists_SendungBelegeDetailsBlock extends Record {
    constructor(SendungNr, Rechnungen) {
        super();
        this.SendungNr = (SendungNr | 0);
        this.Rechnungen = Rechnungen;
    }
}

export function Dashboard_Lists_SendungBelegeDetailsBlock_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.SendungBelegeDetailsBlock", [], Dashboard_Lists_SendungBelegeDetailsBlock, () => [["SendungNr", int32_type], ["Rechnungen", list_type(Dashboard_Lists_SendungBelegeDetails_$reflection())]]);
}

export class Dashboard_Lists_AnstehendeZahlungDetails extends Record {
    constructor(RechnungsNrExtern, KlientPatient, LeistungsGrundlage, Faelligkeitsdatum, Rechnungsbetrag) {
        super();
        this.RechnungsNrExtern = RechnungsNrExtern;
        this.KlientPatient = KlientPatient;
        this.LeistungsGrundlage = LeistungsGrundlage;
        this.Faelligkeitsdatum = Faelligkeitsdatum;
        this.Rechnungsbetrag = Rechnungsbetrag;
    }
}

export function Dashboard_Lists_AnstehendeZahlungDetails_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.AnstehendeZahlungDetails", [], Dashboard_Lists_AnstehendeZahlungDetails, () => [["RechnungsNrExtern", string_type], ["KlientPatient", string_type], ["LeistungsGrundlage", string_type], ["Faelligkeitsdatum", class_type("System.DateTime")], ["Rechnungsbetrag", decimal_type]]);
}

export class Dashboard_Lists_AnstehendeZahlungDetailsBlock extends Record {
    constructor(SendungNr, Summe, Faelligkeit, Rechnungen) {
        super();
        this.SendungNr = (SendungNr | 0);
        this.Summe = Summe;
        this.Faelligkeit = Faelligkeit;
        this.Rechnungen = Rechnungen;
    }
}

export function Dashboard_Lists_AnstehendeZahlungDetailsBlock_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.AnstehendeZahlungDetailsBlock", [], Dashboard_Lists_AnstehendeZahlungDetailsBlock, () => [["SendungNr", int32_type], ["Summe", decimal_type], ["Faelligkeit", class_type("System.DateTime")], ["Rechnungen", list_type(Dashboard_Lists_AnstehendeZahlungDetails_$reflection())]]);
}

export class Dashboard_Lists_DokumentenDepot extends Record {
    constructor(LagerplatzReportId, SendungNr, RechnungsNrExtern, KlientPatient, DokumentArt, Grund, EingelagertAm, RuecksendungAm, IsChecked, AuslagerungAngefordert, ZeitAuslagerung) {
        super();
        this.LagerplatzReportId = LagerplatzReportId;
        this.SendungNr = (SendungNr | 0);
        this.RechnungsNrExtern = RechnungsNrExtern;
        this.KlientPatient = KlientPatient;
        this.DokumentArt = DokumentArt;
        this.Grund = Grund;
        this.EingelagertAm = EingelagertAm;
        this.RuecksendungAm = RuecksendungAm;
        this.IsChecked = IsChecked;
        this.AuslagerungAngefordert = AuslagerungAngefordert;
        this.ZeitAuslagerung = ZeitAuslagerung;
    }
}

export function Dashboard_Lists_DokumentenDepot_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Dashboard.Lists.DokumentenDepot", [], Dashboard_Lists_DokumentenDepot, () => [["LagerplatzReportId", class_type("System.Guid")], ["SendungNr", int32_type], ["RechnungsNrExtern", string_type], ["KlientPatient", string_type], ["DokumentArt", string_type], ["Grund", string_type], ["EingelagertAm", class_type("System.DateTime")], ["RuecksendungAm", option_type(class_type("System.DateTime"))], ["IsChecked", bool_type], ["AuslagerungAngefordert", option_type(class_type("System.DateTime"))], ["ZeitAuslagerung", option_type(class_type("System.DateTime"))]]);
}

export class ChatBot_Filter extends Record {
    constructor(SendungsNr, RechnungsNrExtern, AbrechnungVon, AbrechnungBis, Nachname, Vorname, Geburtsdatum, Geschlecht, Rechnungsempfaenger) {
        super();
        this.SendungsNr = SendungsNr;
        this.RechnungsNrExtern = RechnungsNrExtern;
        this.AbrechnungVon = AbrechnungVon;
        this.AbrechnungBis = AbrechnungBis;
        this.Nachname = Nachname;
        this.Vorname = Vorname;
        this.Geburtsdatum = Geburtsdatum;
        this.Geschlecht = Geschlecht;
        this.Rechnungsempfaenger = Rechnungsempfaenger;
    }
}

export function ChatBot_Filter_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.Filter", [], ChatBot_Filter, () => [["SendungsNr", option_type(int32_type)], ["RechnungsNrExtern", option_type(string_type)], ["AbrechnungVon", option_type(class_type("System.DateTime"))], ["AbrechnungBis", option_type(class_type("System.DateTime"))], ["Nachname", option_type(string_type)], ["Vorname", option_type(string_type)], ["Geburtsdatum", option_type(class_type("System.DateTime"))], ["Geschlecht", option_type(string_type)], ["Rechnungsempfaenger", option_type(string_type)]]);
}

export class ChatBot_Field extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Vorname", "Nachname", "RechnungsNrExtern", "AbrechnungVon", "AbrechnungBis", "Geschlecht", "SendungsNr", "Geburtsdatum", "Rechnungsempfaenger", "Unknown"];
    }
}

export function ChatBot_Field_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.Field", [], ChatBot_Field, () => [[], [], [], [], [], [], [], [], [], [["Item", string_type]]]);
}

export class ChatBot_RechnungCandidate extends Record {
    constructor(Vorname, Nachname, RechnungsNrExtern, AbrechnungVon, AbrechnungBis, Geschlecht, SendungsNr, Geburtsdatum, Rechnungsempfaenger) {
        super();
        this.Vorname = Vorname;
        this.Nachname = Nachname;
        this.RechnungsNrExtern = RechnungsNrExtern;
        this.AbrechnungVon = AbrechnungVon;
        this.AbrechnungBis = AbrechnungBis;
        this.Geschlecht = Geschlecht;
        this.SendungsNr = (SendungsNr | 0);
        this.Geburtsdatum = Geburtsdatum;
        this.Rechnungsempfaenger = Rechnungsempfaenger;
    }
}

export function ChatBot_RechnungCandidate_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.RechnungCandidate", [], ChatBot_RechnungCandidate, () => [["Vorname", string_type], ["Nachname", string_type], ["RechnungsNrExtern", string_type], ["AbrechnungVon", class_type("System.DateTime")], ["AbrechnungBis", class_type("System.DateTime")], ["Geschlecht", string_type], ["SendungsNr", int32_type], ["Geburtsdatum", class_type("System.DateTime")], ["Rechnungsempfaenger", string_type]]);
}

export class ChatBot_BaseResult {
    constructor(resultType) {
        this["ResultType@"] = resultType;
    }
}

export function ChatBot_BaseResult_$reflection() {
    return class_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.BaseResult", undefined, ChatBot_BaseResult);
}

export function ChatBot_BaseResult_$ctor_Z721C83C5(resultType) {
    return new ChatBot_BaseResult(resultType);
}

export function ChatBot_BaseResult__get_ResultType(__) {
    return __["ResultType@"];
}

export class ChatBot_NoResult extends ChatBot_BaseResult {
    constructor(resultType) {
        super(resultType);
    }
}

export function ChatBot_NoResult_$reflection() {
    return class_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.NoResult", undefined, ChatBot_NoResult, ChatBot_BaseResult_$reflection());
}

export function ChatBot_NoResult_$ctor_Z721C83C5(resultType) {
    return new ChatBot_NoResult(resultType);
}

export function ChatBot_NoResult_$ctor() {
    return ChatBot_NoResult_$ctor_Z721C83C5("NoResult");
}

export class ChatBot_SingleResult extends ChatBot_BaseResult {
    constructor(resultType, result) {
        super(resultType);
        this["Result@"] = result;
    }
}

export function ChatBot_SingleResult_$reflection() {
    return class_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.SingleResult", undefined, ChatBot_SingleResult, ChatBot_BaseResult_$reflection());
}

export function ChatBot_SingleResult_$ctor_433E080(resultType, result) {
    return new ChatBot_SingleResult(resultType, result);
}

export function ChatBot_SingleResult__get_Result(__) {
    return __["Result@"];
}

export function ChatBot_SingleResult_$ctor_4E60E31B(result) {
    return ChatBot_SingleResult_$ctor_433E080("SingleResult", result);
}

export class ChatBot_MultipleResult extends ChatBot_BaseResult {
    constructor(resultType, nextBestProperties) {
        super(resultType);
        this["Result@"] = nextBestProperties;
    }
}

export function ChatBot_MultipleResult_$reflection() {
    return class_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.MultipleResult", undefined, ChatBot_MultipleResult, ChatBot_BaseResult_$reflection());
}

export function ChatBot_MultipleResult_$ctor_433E080(resultType, nextBestProperties) {
    return new ChatBot_MultipleResult(resultType, nextBestProperties);
}

export function ChatBot_MultipleResult__get_Result(__) {
    return __["Result@"];
}

export function ChatBot_MultipleResult_$ctor_4E60E31B(nextBestProperties) {
    return ChatBot_MultipleResult_$ctor_433E080("MultipleResult", nextBestProperties);
}

export class ChatBot_TokenResult extends Record {
    constructor(ApiKey, Token) {
        super();
        this.ApiKey = ApiKey;
        this.Token = Token;
    }
}

export function ChatBot_TokenResult_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.ChatBot.TokenResult", [], ChatBot_TokenResult, () => [["ApiKey", string_type], ["Token", string_type]]);
}

export class Notifications_Subscription extends Record {
    constructor(Endpoint, P256DH, Auth) {
        super();
        this.Endpoint = Endpoint;
        this.P256DH = P256DH;
        this.Auth = Auth;
    }
}

export function Notifications_Subscription_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Notifications.Subscription", [], Notifications_Subscription, () => [["Endpoint", string_type], ["P256DH", string_type], ["Auth", string_type]]);
}

export class Notifications_EndpointIdentifier extends Record {
    constructor(Endpoint) {
        super();
        this.Endpoint = Endpoint;
    }
}

export function Notifications_EndpointIdentifier_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Notifications.EndpointIdentifier", [], Notifications_EndpointIdentifier, () => [["Endpoint", string_type]]);
}

export class Notifications_MessageIdentifier extends Record {
    constructor(Id) {
        super();
        this.Id = Id;
    }
}

export function Notifications_MessageIdentifier_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Notifications.MessageIdentifier", [], Notifications_MessageIdentifier, () => [["Id", class_type("System.Guid")]]);
}

export class Sepa_OpenMandatData extends Record {
    constructor(FilialeName1, FilialeName2, Rechnungsempfaenger) {
        super();
        this.FilialeName1 = FilialeName1;
        this.FilialeName2 = FilialeName2;
        this.Rechnungsempfaenger = Rechnungsempfaenger;
    }
}

export function Sepa_OpenMandatData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.OpenMandatData", [], Sepa_OpenMandatData, () => [["FilialeName1", string_type], ["FilialeName2", string_type], ["Rechnungsempfaenger", string_type]]);
}

export class Sepa_GrantedMandatData extends Record {
    constructor(HasConfirmation, Rechnungsempfaenger) {
        super();
        this.HasConfirmation = HasConfirmation;
        this.Rechnungsempfaenger = Rechnungsempfaenger;
    }
}

export function Sepa_GrantedMandatData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.GrantedMandatData", [], Sepa_GrantedMandatData, () => [["HasConfirmation", bool_type], ["Rechnungsempfaenger", string_type]]);
}

export class Sepa_OpenMandat extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "Granted", "InProgress", "Open"];
    }
}

export function Sepa_OpenMandat_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.OpenMandat", [], Sepa_OpenMandat, () => [[], [["Item", Sepa_GrantedMandatData_$reflection()]], [["Item", Sepa_OpenMandatData_$reflection()]], [["Item", Sepa_OpenMandatData_$reflection()]]]);
}

export class Sepa_MandatKontoinhaber extends Record {
    constructor(Kontoinhaber, Strasse, Hausnummer, Plz, Ort) {
        super();
        this.Kontoinhaber = Kontoinhaber;
        this.Strasse = Strasse;
        this.Hausnummer = Hausnummer;
        this.Plz = Plz;
        this.Ort = Ort;
    }
}

export function Sepa_MandatKontoinhaber_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.MandatKontoinhaber", [], Sepa_MandatKontoinhaber, () => [["Kontoinhaber", string_type], ["Strasse", string_type], ["Hausnummer", string_type], ["Plz", string_type], ["Ort", string_type]]);
}

export class Sepa_SaveMandatData extends Record {
    constructor(Kontoinhaber, Bevollmaechtigter, Iban, AllowForOldPayments) {
        super();
        this.Kontoinhaber = Kontoinhaber;
        this.Bevollmaechtigter = Bevollmaechtigter;
        this.Iban = Iban;
        this.AllowForOldPayments = AllowForOldPayments;
    }
}

export function Sepa_SaveMandatData_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.SaveMandatData", [], Sepa_SaveMandatData, () => [["Kontoinhaber", option_type(Sepa_MandatKontoinhaber_$reflection())], ["Bevollmaechtigter", option_type(string_type)], ["Iban", string_type], ["AllowForOldPayments", bool_type]]);
}

export class Sepa_SaveMandatResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AlreadyCompleted", "InvalidId", "InvalidIban", "InvalidKontoinhaber", "InvalidStrasse", "InvalidHausnummer", "InvalidPlz", "InvalidOrt", "InvalidBevollmaechtigter", "Ok"];
    }
}

export function Sepa_SaveMandatResult_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Sepa.SaveMandatResult", [], Sepa_SaveMandatResult, () => [[], [], [], [], [], [], [], [], [], []]);
}

export class Benachrichtigungen_TicketBenachrichtigung extends Record {
    constructor(TicketId, TicketAntwortId, ItsForMe) {
        super();
        this.TicketId = TicketId;
        this.TicketAntwortId = TicketAntwortId;
        this.ItsForMe = ItsForMe;
    }
}

export function Benachrichtigungen_TicketBenachrichtigung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Benachrichtigungen.TicketBenachrichtigung", [], Benachrichtigungen_TicketBenachrichtigung, () => [["TicketId", class_type("System.Guid")], ["TicketAntwortId", class_type("System.Guid")], ["ItsForMe", bool_type]]);
}

export class Benachrichtigungen_BenachrichtigungsTyp extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["News", "Document", "TicketAntwort"];
    }
}

export function Benachrichtigungen_BenachrichtigungsTyp_$reflection() {
    return union_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Benachrichtigungen.BenachrichtigungsTyp", [], Benachrichtigungen_BenachrichtigungsTyp, () => [[["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", Benachrichtigungen_TicketBenachrichtigung_$reflection()]]]);
}

export class Benachrichtigungen_Benachrichtigung extends Record {
    constructor(BenachrichtigungsTyp, Titel, Beschreibung, IstNeu) {
        super();
        this.BenachrichtigungsTyp = BenachrichtigungsTyp;
        this.Titel = Titel;
        this.Beschreibung = Beschreibung;
        this.IstNeu = IstNeu;
    }
}

export function Benachrichtigungen_Benachrichtigung_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Benachrichtigungen.Benachrichtigung", [], Benachrichtigungen_Benachrichtigung, () => [["BenachrichtigungsTyp", Benachrichtigungen_BenachrichtigungsTyp_$reflection()], ["Titel", string_type], ["Beschreibung", string_type], ["IstNeu", bool_type]]);
}

export class Benachrichtigungen_IBenachrichtigungenService extends Record {
    constructor(HasUnreadNotifications, GetNotifications, MarkAllAsRead) {
        super();
        this.HasUnreadNotifications = HasUnreadNotifications;
        this.GetNotifications = GetNotifications;
        this.MarkAllAsRead = MarkAllAsRead;
    }
}

export function Benachrichtigungen_IBenachrichtigungenService_$reflection() {
    return record_type("Bfs.Web.Data.Service.Contracts.Kundenportal.Benachrichtigungen.IBenachrichtigungenService", [], Benachrichtigungen_IBenachrichtigungenService, () => [["HasUnreadNotifications", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [bool_type]))], ["GetNotifications", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [list_type(Benachrichtigungen_Benachrichtigung_$reflection())]))], ["MarkAllAsRead", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [unit_type]))]]);
}

//# sourceMappingURL=Kundenportal.Contracts.fs.js.map
